import { TRDRFooter } from "@/components/layout/trdr-footer";
import { TRDRHeader } from "@/components/layout/trdr-header";
import { ToolsSection } from "@/components/sections/tools-section";

const ToolsPage = () => {
  return (
    <div className="min-h-screen bg-[#00261C]">
      <TRDRHeader />
      <main>
        <section className="border-b border-[#EDF5F2]/10 px-4 pb-8 pt-36 text-center sm:px-6 md:pt-40">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-[#B2F273]">
            TRDRHub offerings
          </p>
          <h1 className="mx-auto mt-4 max-w-4xl font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Choose the delivery model that fits the work.
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-[#EDF5F2]/60">
            Run defined checks through the software. Bring complex cases, historical data, and
            institutional reviews to Enso as managed engagements.
          </p>
        </section>
        <ToolsSection />
      </main>
      <TRDRFooter />
    </div>
  );
};

export default ToolsPage;
